export const keyDownFunctions = {
  handleEnterKeyDown
}

function handleEnterKeyDown(func) {
  return function(e) {
    e.keyCode === 13 && func()
  }
}